<template>
  <div>
    <!-- 내용물 -->
    <div style="display: flex;">
      <div style="margin: 0 auto; width: 100px; text-align: center; border: 1px solid #CDCDCD;">
        <p style="padding: 5px 1rem; border-bottom: 1px solid #CDCDCD; background-color: #F9F9F9; font-weight: 500;">{{ value.title }}</p>
        <p style="padding: 5px 1rem;">{{ value.name }}</p>
      </div>
    </div>

    <!-- 여러 자식이 있을 경우 -->
    <div v-if="value.child && value.child.length > 1" style="height: 60px;">
      <span style="display: block; height: 100%; width: 1px; margin: 0 auto; background-color: #cdcdcd;" />
      <div style="width: 100%; height: 1px;" :style="{paddingLeft: paddingLeft(value), paddingRight: paddingRight(value)}">
        <span style="display: block; width: 100%; height: 100%; background-color: #cdcdcd;" />
      </div>
    </div>

    <div style="display: flex; gap: 10px;">
      <print-node v-for="child of value.child" :value="child"/>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PrintNode',
  props: {
    value: Object,
  },
  methods: {
    paddingLeft (value) {
      const total = value.child[0].totalChildCount
      const padding = 5 * (total - 1)
      return `${(50 * total) + padding}px`
    },
    paddingRight (value) {
      const total = value.child[value.child.length - 1].totalChildCount
      const padding = 5 * (total - 1)
      return `${(50 * total) + padding}px`
    }
  }
}
</script>

<style lang="scss" scoped>
.card-top {
  display: flex; justify-content: center; height: 60px;
  span {  height: 100%; width: 1px; background-color: #cdcdcd;}
}

.card-bottom {
  height: 60px;
  & > span { display: block; height: 100%; width: 1px; margin: 0 auto; background-color: #cdcdcd;}
  .bottom-bar {
    width:100%;
    height:1px;
    & > span {
      display: block;
      width: 100%;
      height: 100%;
      background-color: #cdcdcd;
    }
  }
}

.child {
  display: flex;
  gap: 10px;
}

.card-body {
  display: flex;

  .card-content {
    margin: 0 auto;
    width: 186px;
    text-align: center;
    border: 1px solid #CDCDCD;

    p { padding: 10px 1rem; }
    p:first-child {
      border-bottom: 1px solid #CDCDCD;
      background-color: #F9F9F9;
      font-weight: 500;
    }
  }
}
</style>
